'use client'

import { createContext, type PropsWithChildren, useContext } from 'react'

const SessionIdContext = createContext<string | undefined>(undefined)

/**
 * Provides the server-minted `mo-session-id` value to client components.
 *
 * The session cookie is HttpOnly, so client JS cannot read it via
 * `document.cookie`. Server components read it from the request headers
 * and pass it down through this provider. Client consumers (e.g.
 * `AppActionFlowProvider`) call {@link useSessionId} to include it in
 * observability context for log/analytics correlation with server-side
 * request logs.
 */
export function SessionIdProvider({
  sessionId,
  children
}: PropsWithChildren<{ sessionId: string | undefined }>) {
  return <SessionIdContext.Provider value={sessionId}>{children}</SessionIdContext.Provider>
}

/** Read the session ID bridged from the server via {@link SessionIdProvider}. */
export function useSessionId(): string | undefined {
  return useContext(SessionIdContext)
}
